export default __webpack_public_path__ + "static/media/VA.f1b37d70.svg";